export const initEchartLineOption = ({xData, yFormatter, maxData, maxBarData, maxBarData2, startValue, other} = {}, {simple, title} = {}) => {
  let option = {
    title: title ? {
      text: title,
      top: '0',
      left: 'center',
      textStyle: {
        color: '#657180',
        fontSize: 12,
        align: 'center'
      }
    } : {},
    animation: false,
    grid: simple ? [{
      top: !title ? '10px' : '20px',
      left: '30px',
      bottom: '20px',
      right: '35px'
    }] : [{
      top: '30px',
      left: '60px',
      bottom: '20px',
      right: '60px'
    }],
    color: ['#fe6800', '#0075c7'],
    tooltip: makeTooltip(other),
    toolbox: simple ? {} : makeToolbox(),
    xAxis: makeXAxis(xData, simple),
    yAxis: makeYAxis(yFormatter, maxData, maxBarData, maxBarData2, other, simple),
    visualMap: {
      show: false,
      pieces: [{
        gt: 0,
        lte: 1,
        color: '#67C23A'
      }],
      outOfRange: {
        color: '#F56C6C'
      },
      seriesIndex: 0
    }
  }
  // if (startValue && !simple) {
  //   option.dataZoom = [{
  //     type: 'inside',
  //     show: false,
  //     // startValue: startValue,
  //     startValue: 0,
  //     minValueSpan: 5
  //   },
  //   {
  //     backgroundColor: 'rgba(0,0,0,0)',
  //     fillerColor: 'rgba(0,0,0,0)',
  //     type: 'slider',
  //     borderColor: 'rgba(0,0,0,0)',
  //     dataBackground: {
  //       areaStyle: {
  //         color: 'rgba(0,0,0,0)'
  //       },
  //       lineStyle: {
  //         color: 'rgba(0,0,0,0)'
  //       }
  //     }
  //   }]
  // }
  return option
}

// 跨区原因统计
export const initOptionBarKqyy = (data, xData) => {
  let option = {
    color: ['#e7a32e'],
    tooltip: {
      trigger: 'item',
      formatter: '{b}<br/> {c}'
    },
    toolbox: makeToolbox(),
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10',
      top: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xData,
      axisLabel: {
        rotate: -20
      }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      name: ''
    },
    series: [{
      barWidth: 10,
      name: '',
      type: 'bar',
      data: data,
      barMinHeight: 5
    }]
  }
  return option
}

// 配送销量排行榜图
export const initOptionBarPsxl = (data, xData, title, dw) => {
  let option = {
    title: {
      text: title,
      textStyle: {
        color: '#999',
        fontWeight: 400,
        fontSize: 16
      }
    },
    color: ['#e7a32e'],
    tooltip: {
      trigger: 'item',
      formatter: '{b}<br/> {c}' + (dw || 'km/h')
    },
    toolbox: makeToolbox(),
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10',
      top: dw ? '20%' : '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xData,
      axisLabel: {
        rotate: 90
      }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      name: dw || ''
    },
    series: [{
      barWidth: 10,
      name: '',
      type: 'bar',
      data: data,
      barMinHeight: 5
    }]
  }
  return option
}

// 油库装油时间分布图
export const initOptionBarDLTD = (data, xData, total) => {
  let option = {
    color: ['#e7a32e'],
    tooltip: {
      trigger: 'axis',
      formatter: function (data, a1, a2) {
        let rdata = data[0]
        return rdata.data ? (rdata.axisValue + '<br/>' + rdata.data + '趟 ' + (rdata.data / total * 100).toFixed(1) + '%') : (rdata.axisValue + '<br/>无装油')
      }
    },
    toolbox: makeToolbox(),
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xData
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      }
    },
    series: [{
      barWidth: 10,
      name: '',
      type: 'bar',
      data: data,
      barMinHeight: 5
    }]
  }
  return option
}

export const initOptionPie = (datas, name, showLegend) => {
  let option = {}
  option.color = showLegend ? [] : ['#67C23A', '#E6A23C', '#dcdddd', '#F56C6C']
  option.title = {
    text: name,
    x: 'center',
    textStyle: {
      color: '#fff',
      bottom: '20px',
      fontStyle: 'normal',
      fontWeight: '200',
      fontSize: '14px'
    }
  }
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  }
  option.series = [{
    name: name,
    type: 'pie',
    selectedMode: 'single',
    label: {
      normal: {
        show: showLegend
      }
    },
    data: datas
  }]
  return option
}

export const initOptionPiePsState = (datas) => {
  let option = {}
  option.tooltip = {
    trigger: 'item',
    formatter: '{b}: {c}吨 ({d}%)'
  }
  option.series = [{
    name: '配送状态',
    type: 'pie',
    selectedMode: 'single',
    label: {
      normal: {
        show: true,
        position: 'inner'
      }
    },
    data: datas
  }]
  return option
}

export const initOptionPiePsState2 = (datas) => {
  let option = {}
  option.color = ['#8fc8ad', '#c4332b']
  option.tooltip = {
    trigger: 'item',
    formatter: '{b}: {c}单 ({d}%)'
  }
  option.series = [{
    name: '配送状态',
    type: 'pie',
    selectedMode: 'single',
    label: {
      normal: {
        show: true,
        position: 'inner'
      }
    },
    data: datas
  }]
  return option
}

export const initGasBarLine2 = (datas, xDatas, title) => {
  let option = {
    color: ['#16895e', '#ffd600', '#f06501', '#000', '#67C23A'],
    textStyle: {
      color: '#fff'
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{b} <br/>{a}: {c}吨<br/>{a1}: {c1}吨<br/>{a2}: {c2}吨<br/>{a3}: {c3}吨<br/>{a4}: {c4}%'
    },
    title: {
      text: title,
      left: 10,
      textStyle: {
        color: '#fff',
        fontSize: 16,
        backgroundColor: '#17484d'
      }
    },
    legend: {
      right: 40,
      data: ['0#', '92#', '95#', '98#'],
      textStyle: {
        color: '#fff'
      }
    },
    grid: {
      left: '60px',
      bottom: '30px',
      top: '50px',
      right: '60px'
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      data: xDatas
    }],
    yAxis: [{
      type: 'value',
      name: '销量',
      position: 'left',
      axisLabel: {
        formatter: '{value} 吨'
      },
      splitLine: {
        show: false
      }
    },
    {
      type: 'value',
      name: '环比',
      position: 'right',
      axisLabel: {
        formatter: '{value} %'
      }
    }],
    series: [{
      name: '0#',
      type: 'bar',
      stack: '销量',
      yAxisIndex: 0,
      barWidth: 10,
      data: datas[0]
    },
    {
      name: '92#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[1]
    },
    {
      name: '95#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[2]
    },
    {
      name: '98#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[3]
    },
    {
      name: '环比',
      type: 'line',
      yAxisIndex: 1,
      data: datas[4]
    }]
  }
  return option
}

export const initGasBarLine = (datas, xDatas, title) => {
  let option = {
    color: ['#16895e', '#ffd600', '#f06501', '#000', '#67C23A'],
    tooltip: {
      trigger: 'axis',
      formatter: '{b} <br/>{a}: {c}吨<br/>{a1}: {c1}吨<br/>{a2}: {c2}吨<br/>{a3}: {c3}吨<br/>{a4}: {c4}%'
    },
    title: {
      text: title,
      left: 10,
      textStyle: {
        fontSize: 16
      }
    },
    legend: {
      right: 40,
      data: ['0#', '92#', '95#', '98#']
    },
    grid: {
      left: '60px',
      bottom: '30px',
      top: '50px',
      right: '60px'
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      data: xDatas
    }],
    yAxis: [{
      type: 'value',
      name: '销量',
      position: 'left',
      axisLabel: {
        formatter: '{value} 吨'
      },
      splitLine: {
        show: false
      }
    },
    {
      type: 'value',
      name: '环比',
      position: 'right',
      axisLabel: {
        formatter: '{value} %'
      }
    }],
    series: [{
      name: '0#',
      type: 'bar',
      stack: '销量',
      yAxisIndex: 0,
      barWidth: 10,
      data: datas[0]
    },
    {
      name: '92#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[1]
    },
    {
      name: '95#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[2]
    },
    {
      name: '98#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[3]
    },
    {
      name: '环比',
      type: 'line',
      yAxisIndex: 1,
      data: datas[4]
    }]
  }
  return option
}

export const initGasBarLineNew = (datas, xDatas, title) => {
  let tColor = '#ddd'
  let option = {
    color: ['#20adae', '#498dca', '#6b59c7', '#494e85'],
    tooltip: {
      trigger: 'axis',
      formatter: '{b} <br/>{a}: {c}吨<br/>{a1}: {c1}吨<br/>{a2}: {c2}吨<br/>{a3}: {c3}吨<br/>{a4}: {c4}%'
    },
    title: {
      text: title,
      left: 10,
      textStyle: {
        fontSize: 16,
        color: '#1c73cd'
      }
    },
    legend: {
      right: 40,
      data: ['0#', '92#', '95#', '98#'],
      textStyle: {
        color: tColor
      }
    },
    grid: {
      left: '60px',
      bottom: '30px',
      top: '50px',
      right: '60px'
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        color: tColor
      },
      data: xDatas
    }],
    yAxis: [{
      type: 'value',
      name: '销量',
      position: 'left',
      axisLabel: {
        formatter: '{value} 吨',
        color: tColor
      },
      splitLine: {
        show: false
      }
    },
    {
      type: 'value',
      name: '环比',
      position: 'right',
      axisLabel: {
        formatter: '{value} %'
      }
    }],
    series: [{
      name: '0#',
      type: 'bar',
      stack: '销量',
      yAxisIndex: 0,
      barWidth: 10,
      data: datas[0]
    },
    {
      name: '92#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[1]
    },
    {
      name: '95#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[2]
    },
    {
      name: '98#',
      type: 'bar',
      yAxisIndex: 0,
      barWidth: 10,
      stack: '销量',
      data: datas[3]
    },
    {
      name: '环比',
      type: 'line',
      yAxisIndex: 1,
      data: datas[4]
    }]
  }
  return option
}

export const initTopTenBar2 = (datas, yDatas, name, title) => {
  let option = {}
  option.color = ['#00b9ff']
  option.xAxis = {
    type: 'value',
    show: false
  }
  option.grid = {
    left: '50%',
    bottom: '10px',
    top: '30zpx',
    right: '10px'
  }
  option.yAxis = {
    type: 'category',
    data: yDatas,
    axisTick: {
      show: false
    },
    axisLabel: {
      color: '#48d4d2'
    }
  }
  option.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    position: function (point) {
      return {right: 0, top: point[1]}
    },
    formatter: '{b}: {c}吨'
  }
  let series = [{
    name: name,
    type: 'bar',
    barWidth: 7,
    data: datas
  }]
  option.series = series
  return option
}

export const initTopTenBar = (datas, yDatas, name, title) => {
  let option = {}
  option.xAxis = {
    type: 'value',
    show: false
  }
  option.title = {
    text: title,
    bottom: 0,
    x: 'center',
    textStyle: {
      fontSize: 16,
      color: '#666'
    }
  }
  option.grid = {
    left: '50%',
    bottom: '30px',
    top: '1px',
    right: '1px'
  }
  option.yAxis = {
    type: 'category',
    data: yDatas,
    axisTick: {
      show: false
    },
    axisLabel: {
      color: '#222',
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    }
  }
  option.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    position: function (point) {
      return {right: 0, top: point[1]}
    },
    formatter: '{b}: {c}吨'
  }
  let series = [{
    name: name,
    type: 'bar',
    barWidth: 7,
    data: datas
  }]
  option.series = series
  return option
}

export const initTopTenBarNew = (datas, yDatas, name, title) => {
  let option = {}
  option.xAxis = {
    type: 'value',
    show: false
  }
  option.title = {
    text: title,
    top: 10,
    x: 'center',
    textStyle: {
      fontSize: 14,
      color: '#009fee'
    }
  }
  option.color = ['009fee']
  option.grid = {
    left: '50%',
    bottom: '0',
    top: '50px',
    right: '0'
  }
  option.yAxis = {
    type: 'category',
    data: yDatas,
    axisLabel: {
      color: '#009fee'
    }
  }
  option.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    position: function (point) {
      return {right: 0, top: point[1]}
    },
    formatter: '{b}: {c}吨'
  }
  let series = [{
    name: name,
    type: 'bar',
    barWidth: 7,
    data: datas
  }]
  option.series = series
  return option
}

export const initErrorDailyBar = (datas, yDatas) => {
  let option = {}
  option.color = ['#E6A23C']
  option.xAxis = {
    type: 'category',
    data: yDatas,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      color: '#828c95',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      lineHeight: 14,
      formatter: function (val) {
        return val.split('').join('\n')
      }
    }
  }
  option.grid = {
    left: '1px',
    bottom: '50%',
    top: '10px',
    right: '1px'
  }
  option.yAxis = [{
    type: 'value',
    show: false
  }]
  let series = [{
    type: 'bar',
    barWidth: 30,
    label: {
      normal: {
        show: true,
        formatter: '{c}',
        color: '#fff'
      },
      emphasis: {
        show: true,
        formatter: '{c}',
        color: '#fff'
      }
    },
    data: datas
  }]
  option.series = series
  return option
}

export const initOptionPieMap = (datas, name, formatter, colors) => {
  let option = {}
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  }
  option.color = colors || ['#ed8503', '#666', '#5998fe']
  option.grid = {
    right: '1px',
    top: '1px',
    bottom: '1px',
    left: '1px'
  }
  option.series = [{
    name: name,
    type: 'pie',
    selectedMode: 'single',
    label: {
      normal: {
        position: 'inner',
        formatter: formatter || '{b}: {c}',
        show: true
      }
    },
    itemStyle: {
      normal: {
        position: 'inner',
        shadowColor: 'rgba(0, 0, 0, 0.5)',
        shadowBlur: 20
      }
    },
    data: datas,
    animationType: 'scale',
    animationEasing: 'elasticOut',
    animationDelay: function (idx) {
      return Math.random() * 200
    }
  }]
  return option
}

export const initOptionW = (data) => {
  return {
    series: [{
      type: 'liquidFill',
      data: [0.61, 0.5, 0.4, 0.3],
      radius: '50%',
      color: ['#49d088', '#38b470', '#2aaf66'],
      outline: {
        borderDistance: 5,
        itemStyle: {
          borderWidth: 5,
          borderColor: '#13FDCE'
        }
      },
      label: {
        normal: {
          color: '#fff',
          insideColor: '#fff',
          fontSize: 40
        }
      },
      backgroundStyle: {
        color: 'rgba(0,0,0,0.2)'
      }
    }]
  }
}

export const initOptionPieMap2 = (datas, name, formatter, colors) => {
  let option = {}
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  }
  option.color = colors || ['#ed8503', '#666', '#5998fe']
  option.grid = {
    right: '1px',
    top: '1px',
    bottom: '1px',
    left: '1px'
  }
  let rich = {
    white: {
      color: '#ddd',
      align: 'center',
      padding: [3, 0]
    }
  }
  option.series = [{
    name: name,
    type: 'pie',
    radius: [60, 120],
    selectedMode: 'single',
    itemStyle: {
      normal: {
        label: {
          show: true,
          position: 'outside',
          color: '#ddd',
          formatter: function (params) {
            let percent = 0
            let total = 0
            datas.forEach((item) => {
              if (item.data) {
                total += item.data
              }
            })
            if (params.name !== '') {
              percent = ((params.data.data / total) * 100).toFixed(0)
              return params.name + '\n{white|' + '占比' + percent + '%}'
            } else {
              return ''
            }
          },
          rich: rich
        },
        labelLine: {
          length: 30,
          length2: 20,
          show: true,
          color: '#00ffff'
        }
      }
    },
    data: datas,
    animationType: 'scale',
    animationEasing: 'elasticOut',
    animationDelay: function (idx) {
      return Math.random() * 200
    }
  }]
  return option
}

export const updateEchartLineData = ({xData, dataList, topData, btmData, maxData, barData, barData2, maxBarData, maxBarData2, startValue, other} = {}, {simple, title} = {}) => {
  let option = initEchartLineOption({maxData, maxBarData, maxBarData2, startValue, other}, {simple, title})
  option.xAxis = makeXAxis(xData, simple)
  option.series = makeLineSeries(dataList, barData, barData2)
  if (topData && btmData) {
    option.visualMap.pieces[0].gt = btmData
    option.visualMap.pieces[0].lte = topData
  }
  return option
}

const makeTooltip = (other) => {
  let dw = other && other.dw ? other.dw : 'L'
  let formatterFun = (params) => {
    let x1Datas = []
    let realVolume = null
    let dataSource = null
    params.forEach((item) => {
      if (item['axisIndex'] === 0 && item['seriesIndex'] === 0) {
        x1Datas.push(item)
      }
      if (item['seriesName'] === '实际库存量') {
        realVolume = item.data.value
        dataSource = item.data.dataSource
      }
    })
    let parm = x1Datas[0]
    let data = parm.data
    let dateStr = data.xDataOne ? data.xDataOne : ''
    let krStr = data.emptyInventory ? ('<br/>预计空容: ' + data.emptyInventory + dw) : ''
    let rkStr = data.inVolume ? ('<br/>入库量: ' + data.inVolume + dw) : ''
    let ckStr = data.outVolume === 0 || data.outVolume ? ('<br/>销售量: ' + data.outVolume + dw) : ''
    let index = x1Datas.length === 3 ? 2 : 0
    let preSeal = x1Datas[index].value.length ? x1Datas[index].value[1] : x1Datas[index].value
    let pValueStr = preSeal === 0 || preSeal ? ('<br/>预测库存量: ' + preSeal + dw) : ''
    let realVolumeStr = realVolume === 0 || realVolume ? ('<br/>实际库存量: ' + realVolume + dw) : ''
    let dataSourceStr = dataSource ? ('<br/>数据源状态:<br/>' + dataSource) : ''
    let inCountStr = data.inCount ? ('<br/>历史入库次数: ' + data.inCount) : ''
    let ordersStr = ''
    data.orders.forEach((item) => {
      ordersStr = ordersStr + '<br/>' + (item.licenseNo || item.typeText) + ': ' + item.volume + dw + ' ' + item.typeText
    })
    return dateStr + krStr + realVolumeStr + pValueStr + ckStr + rkStr + inCountStr + ordersStr + dataSourceStr
  }
  return {
    formatter: formatterFun,
    trigger: 'axis'
  }
}

const makeToolbox = () => {
  return {
    show: true,
    feature: {
      magicType: {type: ['line', 'bar']},
      saveAsImage: {}
    }
  }
}

const makeXAxis = (xData, simple) => {
  return {
    type: 'category',
    boundaryGap: false,
    splitLine: {
      show: false
    },
    data: xData || [],
    axisTick: {
      show: !simple
    },
    axisLabel: {
      // rotate: 45,
      formatter: function (value, index) {
        return value.includes('00:00') ? value.split(' ')[0] : (Number(value.split(' ')[1].split(':')[0]))
      },
      fontSize: 10,
      color: '#828c95',
      interval: simple ? 'auto' : function (index, value) {
        if (!value) {
          return false
        }
        let data = value.includes('00:00') ? value.split(' ')[0] : (Number(value.split(' ')[1].split(':')[0]))
        data = String(data)
        return data.includes('-') || Number(data) % 4 === 0 || Number(data) === 7
      },
      textStyle: {
        color: function (value, index) {
          if (!value) {
            return null
          }
          let data = value.includes('00:00') ? value.split(' ')[0] : (Number(value.split(' ')[1].split(':')[0]))
          data = String(data)
          return Number(data) === 7 ? 'red' : '#828c95'
        }
      }
    },
    axisLine: {
      lineStyle: {
        color: '#828c95'
      }
    }
  }
}

const makeYAxis = (yFormatter, maxData, maxBarData, maxBarData2, other, simple) => {
  let YAxis = {
    type: 'value',
    name: '',
    minInterval: 10000,
    splitArea: {
      show: true,
      areaStyle: {
        color: ['rgba(99,162,255,0.1)', 'rgba(0,0,0,0.0)']
      }
    },
    axisTick: {
      show: !simple
    },
    splitLine: {
      show: false
    }
  }
  if (simple) {
    YAxis.axisLabel = {
      formatter: function (value) {
        return (value / 10000).toFixed(0) + '万'
      }
    }
  }
  if (other) {
    YAxis.minInterval = null
  }
  if (yFormatter) {
    YAxis.formatter = yFormatter
  }
  if (maxData) {
    YAxis.max = (Number((maxData / 1000).toFixed(0)) + 2) * 1000
    if (other) {
      YAxis.max = maxData
    }
  }
  YAxis.axisLine = {
    lineStyle: {
      color: '#828c95'
    }
  }
  let YAxis2 = {
    type: 'value',
    name: '销量',
    min: 0,
    max: (maxBarData || 0) * 4,
    position: 'right',
    axisLine: {
      lineStyle: {
        color: '#828c95'
      }
    },
    show: false
  }
  let YAxis3 = {
    type: 'value',
    name: '入库统计',
    min: 0,
    max: (maxBarData2 || 0) * 4,
    position: 'right',
    axisLine: {
      lineStyle: {
        color: '#828c95'
      }
    },
    show: false
  }
  return [YAxis, YAxis2, YAxis3]
}

const makeLineSeries = (dataList, barData, barData2) => {
  let series = []
  dataList.forEach((item) => {
    let seriesItem = {
      type: 'line',
      data: item.data,
      name: item.name
    }
    if (item.lineStyle) {
      seriesItem.lineStyle = item.lineStyle
    }
    if (item.showMaxMin) {
      seriesItem.markPoint = {
        data: [{
          type: 'max',
          name: '最大值'
        },
        {
          type: 'min',
          name: '最小值',
          itemStyle: {
            normal: {
              color: '#67C23A'
            }
          }
        }]
      }
    }
    if (item.point) {
      seriesItem.markPoint = {
        data: [],
        label: {
          normal: {
            show: true,
            formatter: function (data) {
              return data.data.value || data.data.coord[1]
            }
          },
          emphasis: {
            show: true,
            formatter: function (data) {
              return data.data.value || data.data.coord[1]
            }
          }
        }
      }
      item.point.forEach((pItem) => {
        if (pItem && pItem.coord) {
          seriesItem.markPoint.data.push({
            coord: pItem.coord,
            value: pItem.value || pItem.coord[1],
            itemStyle: pItem.itemStyle
          })
        } else if (pItem) {
          seriesItem.markPoint.data.push({
            coord: pItem, name: ''
          })
        }
      })
    }
    if (item.areas && item.areas.length > 0) {
      let areaDatas = []
      let color = 'rgba(0, 0, 0, 0.2)'
      item.areas.forEach((itemArea) => {
        color = itemArea.color
        areaDatas.push([{
          name: itemArea.name,
          xAxis: itemArea.x1,
          yAxis: itemArea.y1,
          itemStyle: {
            normal: {
              color: color,
              borderColor: color
            }
          }
        },
        {
          xAxis: itemArea.x2,
          yAxis: itemArea.y2,
          itemStyle: {
            normal: {
              color: color,
              borderColor: color
            }
          }
        }])
      })
      seriesItem.markArea = {
        silent: true,
        itemStyle: {
          normal: {
            borderWidth: 2,
            borderType: 'dashed'
          }
        },
        data: areaDatas
      }
    }
    if (item.lines && item.lines.length > 0) {
      let lineDatas = []
      item.lines.forEach((itemLine) => {
        let lineKey = itemLine.lineType === 'x' ? 'xAxis' : 'yAxis'
        let line = {}
        if (itemLine.formatter) {
          line.label = {
            normal: {
              color: '#828c95',
              show: true,
              formatter: itemLine.formatter
            },
            emphasis: {
              color: '#828c95',
              show: true,
              formatter: itemLine.formatter
            }
          }
        }
        if (itemLine.type === 'label') {
          line.lineStyle = {
            normal: {
              color: 'rgba(0,0,0,0)',
              type: 'solid'
            },
            emphasis: {
              color: 'rgba(0,0,0,0)',
              type: 'solid'
            }
          }
        }
        line[lineKey] = itemLine.value
        lineDatas.push(line)
      })
      seriesItem.markLine = {
        lineStyle: {
          normal: {
            color: '#828c95',
            type: 'solid'
          },
          emphasis: {
            color: '#828c95',
            type: 'solid'
          }
        },
        symbol: 'none',
        data: lineDatas
      }
    }
    series.push(seriesItem)
  })
  if (barData) {
    series.push(barData)
  }
  if (barData2) {
    series.push(barData2)
  }
  return series
}

export const initOptionBarDDj = function (xData, legendData, barData, color) {
  let option = {}
  option.color = color || ['#E6A23C', '#67C23A', '#dcdddd', '#E6A23C', '#67C23A', '#dcdddd']
  option.grid = {
    right: '17%',
    top: '5%',
    bottom: '12%',
    left: 60
  }
  option.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  }
  option.legend = {
    data: legendData,
    orient: 'vertical',
    right: '5%',
    top: '7%',
    textStyle: {
      color: '#fff'
    }
  }
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 11
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }]
  option.series = []
  for (let key in barData) {
    let data = barData[key]
    let oneData = {
      name: key,
      type: 'bar',
      data: data.datas
    }
    if (data['stack']) {
      oneData['stack'] = data['stack']
    }
    option.series.push(oneData)
  }
  return option
}

export const initOptionBarDDj2 = function (xData, legendData, barData, color) {
  let option = {}
  option.color = color || ['#E6A23C', '#67C23A', '#dcdddd', '#E6A23C', '#67C23A', '#dcdddd']
  option.grid = {
    right: '17%',
    top: '5%',
    bottom: '20%',
    left: 60
  }
  option.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  }
  option.legend = {
    data: legendData
  }
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    axisLabel: {
      rotate: -25,
      fontSize: 11
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#fff'
    },
    axisLine: {
      lineStyle: {
        color: '#fff'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }]
  option.series = []
  for (let key in barData) {
    let data = barData[key]
    let oneData = {
      name: key,
      type: 'bar',
      data: data.datas
    }
    if (data['stack']) {
      oneData['stack'] = data['stack']
    }
    option.series.push(oneData)
  }
  return option
}

export const initOptionBarDDjNew = function (xData, legendData, barData, color) {
  let option = {}
  option.color = color || ['#168fff', '#ff0000', '#ff6e00']
  let tColor = '#ddd'
  option.grid = {
    right: 80,
    top: '5%',
    bottom: '15%',
    left: 80
  }
  option.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  }
  option.legend = {
    data: legendData,
    textStyle: {
      color: tColor
    }
  }
  option.xAxis = [{
    type: 'category',
    data: xData,
    axisLine: {
      lineStyle: {
        color: '#ddd'
      }
    },
    axisLabel: {
      fontSize: 9
    },
    axisTick: {
      show: false
    }
  }]
  option.yAxis = [{
    type: 'value',
    textStyle: {
      color: '#ddd'
    },
    axisLine: {
      lineStyle: {
        color: '#ddd'
      }
    },
    splitLine: {
      show: false
    },
    axisTick: {
      inside: true
    }
  }]
  option.series = []
  for (let key in barData) {
    let data = barData[key]
    let oneData = {
      name: key,
      type: 'bar',
      data: data.datas,
      barWidth: 8
    }
    option.series.push(oneData)
  }
  return option
}



// WEBPACK FOOTER //
// ./src/cllib/echart_option.js